import { render, staticRenderFns } from "./DeletePositionDialog.vue?vue&type=template&id=7a2bd5f9"
import script from "./DeletePositionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletePositionDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports